import React from "react";
import logo from "../../assets/image/Clisha-logo.png";

export function LogoClisha({ className }: { className?: string }) {
    return <img src={logo} alt="Logo" className={` ${className ?? ""}`} />;
}
